import { createAction } from "redux-actions";
import * as ActionTypes from "../../../actionTypes";
import WorkFlowController from "../../../services/workflowController";
import { userAccessTokenSelector } from "../../../security";

const workflowController = new WorkFlowController();

type Action = {
  +type: string,
  +payload?: any,
  +error?: boolean,
  +meta?: any
};

export const fetchBTUMeterReadingsRequested: Action = createAction(
  ActionTypes.FETCH_BTU_METER_READINGS_REQUESTED
);

export const fetchBTUMeterReadingsReceived: Action = createAction(
  ActionTypes.FETCH_BTU_METER_READINGS_RECEIVED
);

export const fetchBTUMeterReadingsFailed: Action = createAction(
  ActionTypes.FETCH_BTU_METER_READINGS_FAILED
);

// TODO remoce the 'currentBtuReading' RM now this is broken
const fetchCurrentBtuMeterReadings = async (filter, options) =>
  await workflowController.findByFilter("currentMeterReading", filter, options);
export const fetchCurrentBTUMeterReadings = () => async (
  dispatch,
  getState
) => {
  dispatch(fetchBTUMeterReadingsRequested());
  try {
    const filter = {
      where: { meterType: "btu" },
      orderBy: ["locationId ASC", "addressId ASC"]
    };
    const readings = await fetchCurrentBtuMeterReadings(filter, {
      token: userAccessTokenSelector(getState())
    });
    dispatch(fetchBTUMeterReadingsReceived(readings));
  } catch (err) {
    dispatch(fetchBTUMeterReadingsFailed(err.message));
  }
};

export const fetchMeterReadingsRequested: Action = createAction(
  ActionTypes.FETCH_METER_READINGS_REQUESTED
);

export const fetchMeterReadingsReceived: Action = createAction(
  ActionTypes.FETCH_METER_READINGS_RECEIVED
);

export const fetchMeterReadingsFailed: Action = createAction(
  ActionTypes.FETCH_METER_READINGS_FAILED
);

const fetchCurrentMeterReadingsAPI = async (filter, options) =>
  await workflowController.findByFilter("currentMeterReading", filter, options);
export const fetchCurrentMeterReadings = () => async (dispatch, getState) => {
  dispatch(fetchMeterReadingsRequested());
  try {
    const filter = {
      order: ["locationId ASC", "addressId ASC"],
      limit: 2000
    };
    const readings = await fetchCurrentMeterReadingsAPI(filter, {
      token: userAccessTokenSelector(getState())
    });
    dispatch(fetchMeterReadingsReceived(readings));
  } catch (err) {
    dispatch(fetchMeterReadingsFailed(err.message));
  }
};



// WEBPACK FOOTER //
// ./src/features/usage/store/usageActions.js